import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { ProductoEstadoRelacionNotificacionService } from '../../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../../_services/notificaciones.service';
import { forkJoin } from 'rxjs';
import { CanalService } from '../../_services/canal.service';
import { EstadoService } from '../../_services/estado.service';
import { ConfiguracionesCanales } from '../../_models/configuraciones-canales';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfiguracionesCanalesService } from '../../_services/configuraciones-canales.service';
import { Location } from '@angular/common';
import moment from 'moment';
import 'moment/locale/es';

@Component( {
  selector: 'app-canal-estado-form',
  templateUrl: 'canal-estado-form.component.html'
} )

export class CanalEstadoFormComponent implements OnInit {

  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  listaFuncionalidadesControles: FuncionalidadControl[] = [];
  listaCanales: SelectItem[] = [];
  listaEstados: SelectItem[] = [];
  listaSecciones: SelectItem[] = [];
  listaControles: SelectItem[] = [];
  tabSeleccionado = 'INFO';
  configCanal: ConfiguracionesCanales;
  listaConfiguracionesEstadosExistentes: ConfiguracionesCanales[] = [];
  nombreCanal: string;
  nombreEstado: string;

  get fControls() {
    return this.formulario.controls;
  }

  constructor( private navServicio: NavService,
               private conServicio: ConfirmationService,
               private proEstadoCambioServicio: ProductoEstadoRelacionService,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
               private tipCausalesService: TipoCausalCausalSolicitudService,
               private funServicio: FuncionalidadesService,
               private proEstadoRelacionNotificacionServicio: ProductoEstadoRelacionNotificacionService,
               private notServicio: NotificacionesService,
               private canalService: CanalService,
               private estadoService: EstadoService,
               private activeRoute: ActivatedRoute,
               private configCanalService: ConfiguracionesCanalesService,
               private location: Location) {
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.configCanalService.obtenerPorId( params[ 'id' ] ).subscribe( canal => {
          this.configCanal = canal;
          this.cargarDatos();
        } );
      } else {
        this.cargarDatos();
      }
    } );
  }

  cargarDatos() {
    forkJoin(
      this.canalService.listadoCanalesHabilitados(),
      this.estadoService.listadoHabilitados(),
      this.funServicio.obtenerFuncionalidadesControlesPorCodigoFuncionalidad( 'PRODUCTO' )
    ).subscribe( ([canales, estados, funcionalidadesControles]) => {
      this.listaFuncionalidadesControles = funcionalidadesControles;
      this.cargarConfiguracionesExistentes();
      canales.map( c => {
        const item = { label: c.nombre, value: c.idCanal };
        this.listaCanales.push(item);
      });
      estados.map( e => {
        const item = { label: e.nombre, value: e.idEstado };
        this.listaEstados.push(item);
      });
      funcionalidadesControles.map( fc => {
        if ( fc.indicadorSeccion && fc.indicadorHabilitado ) {
          const item = { label: fc.nombre, value: fc.idFuncionalidadControl };
          this.listaSecciones.push(item);
        }
      } );

      if ( this.configCanal ) {
        this.setValoresCanalEstado();
        this.cargarControles( this.configCanal.idSeccion );
      }
      this.cargarFormulario();
      this.carInformacionInicial = false;
    });
  }

  cargarConfiguracionesExistentes() {
    this.configCanalService.listado().subscribe( listaExistentes => {
      this.listaConfiguracionesEstadosExistentes = listaExistentes;
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idConfiguracionCanal: [ this.configCanal ? this.configCanal.idConfiguracionCanal : null ],
      idCanal: [ this.configCanal ? this.configCanal.idCanal : null, [ Validators.required ] ],
      idEstado: [ this.configCanal ? this.configCanal.idEstado : null, [ Validators.required ] ],
      idSeccion: [ this.configCanal ? this.configCanal.idSeccion : null, [ Validators.required ] ],
      idControl: [ this.configCanal ? this.configCanal.idControl : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.configCanal ? this.configCanal.indicadorHabilitado : true ],
      auditoriaFecha: [ this.configCanal ? this.configCanal.auditoriaFecha : null ],
      auditoriaUsuario: [ this.configCanal ? this.configCanal.auditoriaUsuario : null ]
    } );
  }

  cargarControles(idSeccion: string) {
    if ( this.formulario ) {
      this.fControls.idControl.setValue(null);
      this.fControls.idControl.updateValueAndValidity();
    }
    this.listaControles = [];
    const funcControles = this.listaFuncionalidadesControles.filter( x => !x.indicadorSeccion && x.idPadre === idSeccion);
    funcControles.map( fc => {
      if ( fc.indicadorHabilitado ) {
        const item = { label: fc.nombre, value: fc.idFuncionalidadControl };
        this.listaControles.push(item);
      }
    } );
  }

  abrirAcordeon( acordeonIndex: number ) {
    switch ( acordeonIndex ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PASOS';
        break;
      }
      default: {
        break;
      }
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'canal-estado',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_GUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'canal-estado',
        accept: () => {
          this.guardarConfiguracionCanal();
        },
        reject: () => {
        }
      } );
    }
  }

  guardarConfiguracionCanal() {
    this.guardando = true;
    if ( this.validarExistenciaConfiguracion() ) {
      this.showMessage('LBL_INFORMACION', 'Esta combinación de canal y estado, ya se encuentra configurados. No es posible volver a guardar esta información!');
      this.guardando = false;
      return;
    }

    if ( !this.configCanal ) {
      const objGuardar = {
        idConfiguracionCanal: null,
        idCanal: this.fControls.idCanal.value,
        idEstado: this.fControls.idEstado.value,
        idSeccion: this.fControls.idSeccion.value,
        idControl: this.fControls.idControl.value,
        indicadorHabilitado: this.fControls.indicadorHabilitado.value,
        auditoriaFecha: new Date(moment().format())
      } as ConfiguracionesCanales;

      this.configCanalService.crear( objGuardar ).subscribe( resp => {
        this.configCanal = resp;
        this.setValoresCanalEstado();
        this.abrirAcordeon(1);
        this.showMessage('LBL_INFORMACION', 'Se ha creado la configuración de forma exitosa!', 'success');
        this.submitted = false;
        this.guardando = false;
        this.cargarConfiguracionesExistentes();
      }, e => {
        this.guardando = false;
      });
    } else {
      this.configCanal.idSeccion = this.fControls.idSeccion.value;
      this.configCanal.idControl = this.fControls.idControl.value;
      this.configCanal.indicadorHabilitado = this.fControls.indicadorHabilitado.value;
      this.configCanal.auditoriaFecha = new Date(moment().format());

      this.configCanalService.actualizar( this.configCanal ).subscribe( resp => {
        this.showMessage('LBL_INFORMACION', 'Se ha actualizado la configuración de forma exitosa!', 'success');
        this.submitted = false;
        this.guardando = false;
        this.cargarConfiguracionesExistentes();
      }, e => {
        this.guardando = false;
      });
    }
  }

  validarExistenciaConfiguracion() {
    let validate = false;
    if ( this.configCanal ) {
      validate = !!this.listaConfiguracionesEstadosExistentes
        .find( x => x.idConfiguracionCanal !== this.configCanal.idConfiguracionCanal &&
          x.idCanal === this.configCanal.idCanal &&
          x.idEstado === this.configCanal.idEstado);
    } else {
      validate = !!this.listaConfiguracionesEstadosExistentes
        .find( x => x.idCanal === this.fControls.idCanal.value && x.idEstado === this.fControls.idEstado.value);
    }

    return validate;
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

  setValoresCanalEstado() {
    const canal = this.listaCanales.find( x => x.value === this.configCanal.idCanal);
    const estado = this.listaEstados.find( x => x.value === this.configCanal.idEstado);
    this.nombreCanal = canal ? canal.label : null;
    this.nombreEstado = estado ? estado.label : null;
  }

}
